import { ButtonHTMLAttributes } from "react";
import { Check } from "lucide-react";
import { clsx } from "clsx";

export function Checkbox({ checked, className, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { checked: boolean }) {
  return (
    <button
      type="button"
      aria-pressed={checked}
      className={clsx("grid h-5 w-5 shrink-0 place-items-center rounded border transition", checked ? "border-brand-500 bg-brand-500 text-white" : "border-border bg-card hover:border-brand-400 dark:border-border-dark dark:bg-card-dark", className)}
      {...props}
    >
      {checked && <Check className="h-3.5 w-3.5" />}
    </button>
  );
}
